import { useEffect, useState } from 'react';

export default function Header({ status, onOpenDrawer }) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  const utc = now.toUTCString().slice(17, 25);

  return (
    <header className="px-3 sm:px-4 h-12 flex items-center gap-3 bg-slate-900/80 border-b border-slate-800 flex-shrink-0">
      <h1 className="text-base sm:text-lg font-bold tracking-tight">geuspider</h1>

      <div className="ml-auto flex items-center gap-3">
        <div className="hidden sm:flex items-center gap-1 text-xs">
          <span className={`inline-block w-2 h-2 rounded-full ${
            status.connected ? 'bg-emerald-400' : 'bg-red-400'}`} />
          <span className="text-slate-400 font-mono">
            {status.connected ? 'live' : 'offline'}
          </span>
        </div>
        <span className="text-xs sm:text-sm font-mono text-slate-300 tabular-nums">{utc}Z</span>
        <button
          onClick={onOpenDrawer}
          aria-label="open settings"
          className="p-1.5 rounded hover:bg-slate-800 text-slate-300">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="3" />
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09a1.65 1.65 0 0 0-1.08-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
          </svg>
        </button>
      </div>
    </header>
  );
}
